"use client";

import PlayCircleIcon from "@heroicons/react/24/outline/PlayCircleIcon";
import PlayCircleSolidIcon from "@heroicons/react/24/solid/PlayCircleIcon";
import { useEffect, useRef, useState } from "react";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import { useHash } from "react-hash-control";
import ScrollButtons from "./ScrollButtons";
import dynamic from "next/dynamic";

const ModalGallery = dynamic(() => import("./ModalGallery"));

interface props {
  datas: {
    video: {
      youtube_id: string;
    };
  }[];
}

export default function Videos(props: props) {
  const [show, setShow] = useState(false);
  const [activeVideo, setVideo] = useState("");

  const activeId = useHash();

  useEffect(() => {
    if (activeId === "") {
      setShow(false);
    }
  }, [activeId]);

  const videoRef: any = useRef(null);

  return (
    <>
      {props.datas.length > 0 && (
        <div
          id={VENUE_TABS.VIDEOS}
          className="mt-6 relative flex flex-col gap-4 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2"
        >
          {show && (
            <ModalGallery
              show={show}
              closer={() => setShow(false)}
              video={activeVideo}
            />
          )}

          <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2 justify-between items-center">
            <div className="flex gap-2">
              <PlayCircleSolidIcon className="size-5 text-primary" />
              <h2 className="text-primary font-bold text-sm">Videolar</h2>
              <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
                {props.datas.length}
              </div>
            </div>
          </div>

          <div
            ref={videoRef}
            className="overflow-x-auto pb-2 custom-scrollbar flex"
          >
            <ScrollButtons
              refOfTheElement={videoRef}
              lengthOfDatas={props.datas.length}
            />

            <div className="flex gap-4">
              {props.datas.map((video, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setVideo(video.video?.youtube_id);
                      setShow(true);
                    }}
                    style={{
                      backgroundImage: `url('https://img.youtube.com/vi/${video.video?.youtube_id}/0.jpg')`,
                    }}
                    className="rounded-[18px] w-[277px] h-[200px] bg-cover bg-center cursor-pointer flex justify-center items-center"
                  >
                    <PlayCircleIcon className="size-12 text-white" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
